export default __webpack_public_path__ + "static/media/depositWithdrawalIcon8.bf261529.webp";